import * as z from "zod";
import { commerceCloudApiKind } from "./get-commerce-cloud-setup";

export const updateCommerceCloudCredentials = {
  name: "updateCommerceCloudCredentials" as const,
  input: z.object({
    api: commerceCloudApiKind,
    clientId: z.string().min(1),
    clientSecret: z.string().min(1),
  }),
  output: z.null(),
};
